import React from 'react';
import { Layout } from '@/components/layout';
import { Card } from '@/components/ui/Card';
import updatesData from '@/content/updates.json';

interface UpdateEntry {
  date: string;
  details: string[];
}

interface UpdatesContent {
  todos: string[];
  updates: UpdateEntry[];
}

const typedContent = updatesData as UpdatesContent;

const formatDate = (value: string) => {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(parsed);
};

const UpdatesPage: React.FC = () => {
  const todos = typedContent.todos ?? [];
  const updates = typedContent.updates ?? [];

  return (
    <Layout currentPath='/updates'>
      <div className='space-y-8'>
        <div className='text-center'>
          <h1 className='text-3xl font-bold text-text-primary mb-2'>
            网站更新
          </h1>
        </div>

        <Card className='p-8'>
          <h2 className='text-2xl font-semibold text-text-primary mb-6 flex items-center gap-2'>
            <span className='w-1 h-6 bg-glory-gold rounded'></span>
            TODOs
          </h2>
          {todos.length > 0 ? (
            <ul className='list-disc list-inside space-y-2 text-sm text-text-secondary leading-relaxed'>
              {todos.map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
          ) : (
            <p className='text-sm text-text-secondary text-center py-6'>
              暂无待办事项。
            </p>
          )}
        </Card>

        <Card className='p-8'>
          <h2 className='text-2xl font-semibold text-text-primary mb-6 flex items-center gap-2'>
            <span className='w-1 h-6 bg-glory-gold rounded'></span>
            更新日志
          </h2>
          <div className='space-y-6'>
            {updates.length > 0 ? (
              updates.map(update => (
                <div
                  key={update.date}
                  className='rounded-lg border border-border bg-background-primary/60 p-5 space-y-3'
                >
                  <div className='text-sm font-medium text-text-primary'>
                    {formatDate(update.date)}
                  </div>
                  <div className='space-y-2 pl-4 text-sm text-text-secondary leading-relaxed'>
                    {update.details.map((detail, index) => (
                      <p key={`${update.date}-${index}`}>{detail}</p>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <p className='text-sm text-text-secondary text-center py-6'>
                暂无更新记录。
              </p>
            )}
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default UpdatesPage;
